<template>
	<div id="app">
		<div class="nav">
			<img
				src="https://www.sjtu.edu.cn/resource/assets/img/LogoWhite.png"
				alt=""
			/>
			<span
				>School of Electronic, Information & Electrical
				Engineering</span
			>
			<div class="links">
				<div
					v-for="(item, idx) in links"
					:key="idx"
					@click="go(item.route)"
					:class="{ active: item.route == $route.path }"
				>
					<img :src="item.img" alt="" />
					{{ item.label }}
				</div>
			</div>
		</div>
		<div class="body">
			<div class="main">
				<router-view></router-view>
			</div>
		</div>
		<div class="footer">
			<div class="footer-main">
				<div class="left">
					<span class="title">Qunbi Zhuge （诸葛群碧）</span>
					<p>Professor</p>
					<!-- <p>IEEE Senior Member</p> -->
					<p>Department of Electronic Engineering, Shanghai Jiao Tong University</p>
				</div>
				<div class="right">
					<p>
						<i class="el-icon-location"></i>
						Office: SEIEE Building 5-519
					</p>
					<!-- <p>
						<i class="el-icon-phone"></i>
						Tel: +86-21-34205419
					</p> -->
					<p>
						<i class="el-icon-message"></i>
						Email: qunbi.zhuge@sjtu.edu.cn
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import icon0 from '@/assets/Home@2x.png'
import icon1 from '@/assets/Research@2x.png'
import icon2 from '@/assets/Publication@2x.png'
import icon3 from '@/assets/Awards@2x.png'
import icon4 from '@/assets/Services@2x.png'
import icon5 from '@/assets/Teaching@2x.png'
import icon6 from '@/assets/Students@2x.png'
import iconTel from '@/assets/se-icon-f-tel@2x.png'
import iconMail from '@/assets/se-icon-f-mail@2x.png'

export default {
	name: 'app',
	data() {
		return {
			iconTel,
			iconMail,
			links: [
				{ route: '/home', label: 'Home', img: icon0 },
				{ route: '/research', label: 'Research', img: icon1 },
				{ route: '/publication', label: 'Publications', img: icon2 },
				{ route: '/awards', label: 'Awards / Honors', img: icon3 },
				{ route: '/services', label: 'Services', img: icon4 },
				{ route: '/teaching', label: 'Teaching', img: icon5 },
				// { route: '/students', label: 'Students', img: icon6 },
			]
		}
	},
	methods: {
		go(link) {
			if (link == this.$route.fullPath) {
				return
			}
			this.$router.push(link)
		}
	}
}
</script>

<style scoped lang="scss">
.nav {
	background: #10375e;
	padding: 30px 40px;
	position: relative;
	height: 120px;
	> img {
		height: 60px;
	}
	color: rgba(255, 255, 255, 0.55);
	> span {
		position: absolute;
		top: 30px;
		right: 40px;
		font-family: 'Times New Roman', Times, serif;
		font-size: 20px;
	}
	.links {
		height: 52px;
		position: absolute;
		display: flex;
		bottom: 0;
		font-size: 20px;
		font-family: 'Times New Roman', Times, serif;
		right: 40px;
		> div {
			// width: 128px;
			margin-left: 20px;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 16px;
			transition: all 0.2s linear;
			&:hover {
				background: linear-gradient(
					180deg,
					rgba(110, 171, 255, 0) 0%,
					rgba(110, 171, 255, 0.3) 100%
				);
			}
			img {
				width: 16px;
				height: 16px;
				margin-right: 8px;
			}
		}
		.active {
			background: linear-gradient(
				180deg,
				rgba(110, 171, 255, 0) 0%,
				rgba(110, 171, 255, 0.3) 100%
			);
		}
	}
}
.body {
	background: white;
	.main {
		width: 1200px;
		margin: 0 auto;
		padding: 40px 0;
	}
}
.footer {
	background: #10375e;
	height: 180px;
	.footer-main {
		width: 1200px;
		margin: 0 auto;
		padding: 35px 0;
		color: rgba(255, 255, 255, 0.55);
		.title {
			color: rgba(255, 255, 255, 0.85);
			font-size: 26px;
			font-family: 'Times New Roman', Times, serif;
			font-weight: 600;
			margin-bottom: 16px;
			display: block;
		}
		display: flex;
		justify-content: space-between;
		p {
			line-height: 22px;
			margin-bottom: 5px;
			font-size: 18px;
			font-family: 'Times New Roman', Times, serif;
			display: flex;
			align-items: center;
			i {
				font-size: 18px;
				font-family: 'Times New Roman', Times, serif;
				margin-right: 8px;
			}
		}
		.right {
			padding-top: 20px;
		}
	}
}
</style>
